import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4 py-20 bg-background-50">
        <div className="mb-6">
          <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4">
            <i className="ri-error-warning-line text-3xl w-10 h-10 flex items-center justify-center"></i>
          </div>
          <h1 className="font-heading text-4xl md:text-6xl font-bold text-foreground-900 mb-2">
            404
          </h1>
          <p className="text-lg md:text-xl text-foreground-600 font-medium">
            Page Not Found
          </p>
        </div>
        <p className="text-sm text-foreground-500 mb-8 max-w-sm">
          The page you are looking for does not exist or has been moved. Check out our guides below or return to the homepage.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-label text-sm font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
            Back to Homepage
          </Link>
          <Link
            to="/cssbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 border border-background-300/60 font-label text-sm font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
            Read the Guide
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}